<template>
    <div v-if="!isLoading && $store.getters.isLoggedIn && orgRoleIsPermitted($orgRoles.CUSTOMER_FL44)" id="atmo-top" class="purchases_create atmo-page atmo-hash-jump-point">
        <section class="atmo-fast-access-menu">
            <ul class="atmo-container-fixed">
                <li><a href="#purchase-terms">Условия закупки</a></li>
                <li><a href="#supplier-requirements">Требования к участникам закупки</a></li>
                <li><a href="#supply-terms">Условия поставки</a></li>
                <li><a href="#specification">Спецификация</a></li>
                <li><a href="#documents">Документы</a></li>

                <section class="atmo-group">
                    <li title="К верху страницы">
                        <a class="atmo-button-icon" href="#atmo-top"><i class="atmo-icon-angle-up"></i></a>
                    </li>
                    <li title="К низу страницы">
                        <a class="atmo-button-icon" href="#atmo-bottom"><i class="atmo-icon-angle-down"></i></a>
                    </li>
                </section>
            </ul>
        </section>

        <purchase-header-block :organization="customer" :title="isModeEdit ? `Редактирование извещения № ${form.reg_number} 44-ФЗ с неопределённым объёмом` : 'Объявление о закупочной сессии 44-ФЗ с неопределённым объёмом'" />
        <b-container class="my-4 position-relative purchase_session" style="background-color: #f5f5f7">
            <div class="mx-1 mb-4">
                <online-course-regular-button />
            </div>

            <form-row-edit-text v-model="form.purchase_terms.contact_info" label="Дополнительная контактная информация" />
            <form-row-edit-textarea v-model="form.purchase_terms.comment" :rows="5" label="Примечание к закупке (отображается только в ЛК Заказчика)" />

            <h2 id="purchase-terms" class="atmo-hash-jump-point font-weight-bold">Условия закупки</h2>
            <form-row-single-select
                v-model="form.purchase_terms.deliverable_group_id"
                :disabled="restrictions.was_canceled && form.purchase_terms.deliverable_group_id && !$v.form.purchase_terms.deliverable_group_id.$anyDirty"
                :options="dictionaries.deliverable_groups"
                :v="$v.form.purchase_terms.deliverable_group_id"
                label="Предмет закупки"
                placeholder="Выберите предмет закупки" />
            <form-row-edit-text v-model="form.purchase_terms.purchase_object" label="Объект закупки" hint="Укажите непосредственно товары, работы, услуги, поставка, выполнение, оказание которых будут являться предметом контракта." :v="$v.form.purchase_terms.purchase_object" />
            <form-row-single-select
                v-model="form.purchase_terms.order_type_id"
                :options="$globalDictionaries.orderTypes.filter((item) => item.is_fl44)"
                :v="$v.form.purchase_terms.order_type_id"
                label="Тип закупки"
                label-field="title"
                placeholder="Выберите тип закупки"
                @input="form.limits.items = []" />
            <form-row-edit-price v-model="form.purchase_terms.contract_price" label="Цена контракта, руб." :v="$v.form.purchase_terms.contract_price" />
            <form-row-single-select :disabled="restrictions.was_canceled" v-model="form.purchase_terms.duration_type" :options="$globalDictionaries.fl44UnknownVolumePurchaseDurationTypes" :v="$v.form.purchase_terms.duration_type" label="Продолжительность закупочной сессии" placeholder="Выберите продолжительность закупочной сессии" />
            <template v-if="form.purchase_terms.duration_type === 'fast'">
                <form-row-single-select
                    v-model="form.purchase_terms.fast_purchase_justification"
                    :options="dictionaries.urgency_reasons"
                    :v="$v.form.purchase_terms.fast_purchase_justification"
                    label-field="title"
                    label="Причина проведения срочной закупочной сессии"
                    placeholder="Выберите причину проведения срочной закупочной сессии" />
                <form-row-single-line-document-upload :label-cols-lg="3" v-model="form.purchase_terms.fast_purchase_justification_attachment" :v="$v.form.purchase_terms.fast_purchase_justification_attachment" title="Документ обоснования проведения срочной закупочной сессии" />
            </template>
            <form-row-edit-checkbox v-if="withoutLimits" v-model="form.purchase_terms.without_limits" label="Закупка при отсутствии ЛБО (лимитов по КБК)" />
            <form-row-single-select
                v-if="!form.purchase_terms.without_limits"
                v-model="form.purchase_terms.purchase_limit_year"
                :v="$v.form.purchase_terms.purchase_limit_year"
                :options="dictionaries.limitYears"
                label="Год ПГ (Плана-графика)"
                label-field="id"
                placeholder="Выберите год ПГ (Плана-графика)"
                @input="form.limits.items = []" />
            <form-row-edit-checkbox v-model="form.purchase_terms.with_advance" label="Аванс" />
            <form-row-edit-number v-if="form.purchase_terms.with_advance" v-model="form.purchase_terms.advance_percentage" label="Размер аванса, %" :max-value="30" :min-value="1" :v="$v.form.purchase_terms.advance_percentage" />
            <form-row-edit-date v-model="form.purchase_terms.planned_contract_conclusion_date" :min-date="moment().format('YYYY-MM-DD')" :v="$v.form.purchase_terms.planned_contract_conclusion_date" label="Планируемая дата заключения контракта" hint="Не может быть меньше текущей даты." @input="onDateInput" />
            <form-row-edit-date
                v-model="form.purchase_terms.planned_contract_execution_date"
                :disabled="!form.purchase_terms.planned_contract_conclusion_date"
                :min-date="form.purchase_terms.planned_contract_conclusion_date"
                :v="$v.form.purchase_terms.planned_contract_execution_date"
                label="Планируемая дата исполнения контракта"
                hint="Дату можно выбрать только после выбора Планируемой даты заключения контракта." />
            <form-row-edit-textarea
                v-model="form.purchase_terms.unilateral_contract_termination_info"
                :v="$v.form.purchase_terms.unilateral_contract_termination_info"
                :rows="4"
                label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" />

            <h2 id="supplier-requirements" class="atmo-hash-jump-point font-weight-bold">Требования к участникам закупки</h2>
            <form-row-edit-checkbox :label-cols-sm="11" :label-cols-lg="11" form-class="text-right" v-model="form.supplier_requirements.only_smp" :v="$v.form.supplier_requirements.only_smp" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" compact />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.supplier_reqs_rating"
                :v="$v.form.supplier_requirements.supplier_reqs_rating"
                label="Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла"
                compact />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.supplier_reqs_a"
                :v="$v.form.supplier_requirements.supplier_reqs_a"
                label="Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                @input="clearSupplierReqsA"
                compact />
            <supplier-requirement-supplier-reqs-a-edit-table v-if="form.supplier_requirements.supplier_reqs_a" v-model="form.supplier_requirements.supplier_reqs_a_details" :v="$v.form.supplier_requirements.supplier_reqs_a_details" />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.supplier_reqs_b"
                :v="$v.form.supplier_requirements.supplier_reqs_b"
                label="Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ (обязательно)"
                disabled
                compact />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.supplier_reqs_c"
                :v="$v.form.supplier_requirements.supplier_reqs_c"
                label="Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                compact />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.supplier_reqs_sonko"
                :v="$v.form.supplier_requirements.supplier_reqs_sonko"
                label="Участник является социально ориентированной некоммерческой организацией (СОНКО)"
                compact />
            <form-row-edit-checkbox
                :label-cols-sm="11"
                :label-cols-lg="11"
                form-class="text-right"
                v-model="form.supplier_requirements.has_additional_requirements"
                :v="$v.form.supplier_requirements.has_additional_requirements"
                label="Дополнительные требования к участникам закупки"
                @input="clearAdditionalRequirements"
                :compact="form.supplier_requirements.has_additional_requirements" />
            <additional-supplier-requirements-edit-table v-if="form.supplier_requirements.has_additional_requirements" v-model="form.supplier_requirements.additional_requirements" :v="$v.form.supplier_requirements.additional_requirements" />

            <h2 id="supply-terms" class="atmo-hash-jump-point font-weight-bold">Условия поставки</h2>
            <form-row-edit-addresses-new :value.sync="form.delivery_terms.addresses" label="Адрес для доставки/самовывоза" hint="Укажите новый адрес или выберите ранее сохраненный адрес из Адресной книги." compact />
            <form-row-edit-textarea :rows="4" v-model="form.delivery_terms.schedule" label="График поставки товаров (выполнения работ, оказания услуг)" />

            <form-row-specification-table-new id="specification" class="atmo-hash-jump-point" v-model="form.deliverables" :spec-error-message="specErrorMessage" :spec-errors="specErrors" :v="$v.form.deliverables" without-count />
            <limits-editable-table
                v-if="features.kbk_limits && !form.purchase_terms.without_limits"
                v-model="form.limits.items"
                :total-cost="form.purchase_terms.contract_price === null ? 0 : form.purchase_terms.contract_price"
                @validate="limitsValidate"
                :limit-year="form.purchase_terms.purchase_limit_year"
                :order-type="currentOrderType"
                purchase-type="fl44_unknown_volume"
                :purchase-id="purchaseId">
                <template #label-hint>
                    Добавьте или измените лимиты. Необходимо полностью распределить цену контракта по соответствующим лимитам.
                </template>
                <template #info>
                    <p class="fs-14">
                        <b-icon-exclamation-triangle-fill class="text-warning" />&nbsp;Внимание! Перед добавлением лимитов проверьте правильность значений полей "Год ПГ" и "Тип закупки" в разделе "Информация о закупке". При изменении любого из этих полей все добавленные в таблицу лимиты по КБК будут
                        удалены.
                    </p>
                </template>
                <template #label-total>
                    Цена контракта, руб.:
                </template>
                <template #label-variance>
                    Отклонение от цены контракта, руб.:
                </template>
            </limits-editable-table>

            <h2 id="documents" class="atmo-hash-jump-point font-weight-bold">Документы</h2>

            <form-row-single-line-document-upload :label-cols-lg="4" v-model="form.purchase_terms.contract_draft_attachment" :v="$v.form.purchase_terms.contract_draft_attachment" title="Проект ГК" />
            <form-row-single-line-document-upload :label-cols-lg="4" v-model="form.purchase_terms.commercial_proposal_form_attachment" :v="$v.form.purchase_terms.commercial_proposal_form_attachment" title="Образец коммерческого предложения для заполнения" />
            <form-row-single-line-multiple-documents-upload :label-cols-lg="4" title="Дополнительные документы" v-model="form.additional_documents" :v="$v.form.additional_documents" />

            <b-row class="my-3 mt-5">
                <b-col>
                    <b-button class="mr-1 mb-1 text-uppercase" variant="custom-outline-secondary" @click="onCancel">Отменить</b-button>
                    <b-button class="text-uppercase mr-1 mb-1" variant="custom-danger" @click="saveDraft">Сохранить черновик</b-button>
                    <b-button :disabled="!isValid || !$store.getters.getCanSign" class="text-uppercase mr-1 mb-1" variant="custom-green" @click="validateForm">Подписать и сохранить</b-button>
                    <template v-if="!$store.getters.getCanSign">
                        <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                        <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</span>
                    </template>
                </b-col>
            </b-row>
            <b-modal ref="sign-form-modal" v-model="showSignModal" centered no-close-on-backdrop no-close-on-esc scrollable size="lg" title="Подписать извещение" @close="cancelSignModal">
                <template #modal-header-close>
                    <button-close-modal />
                </template>
                <div class="d-block text-left">
                    <b-tabs content-class="mt-3 px-3">
                        <b-tab active>
                            <template #title>
                                <span class="system_link-style fs-16">Форма</span>
                            </template>
                            <h4 class="font-weight-bold">Информация о заказчике</h4>
                            <text-row compact label="Наименование организации" :value="customer.name" />
                            <text-row compact label="ИНН" :value="customer.inn" />
                            <text-row compact label="КПП" :value="customer.kpp" />
                            <text-row compact label="ОГРН" :value="customer.ogrn" />
                            <text-row compact label="Адрес" :value="customer.legal_address" />
                            <text-row compact label="Дополнительная контактная информация" :value="form.purchase_terms.contact_info" />

                            <hr />
                            <h4 class="font-weight-bold">Условия закупки</h4>
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="form.purchase_terms.purchase_object" />
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="dictionaries.deliverable_groups?.find((item) => item.id === form.purchase_terms.deliverable_group_id)?.name" />
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="currentOrderType?.title" />
                            <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="form.purchase_terms.contract_price" />
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="currentDurationType?.name" />
                            <template v-if="form.purchase_terms.duration_type === 'fast'">
                                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Причина проведения срочной закупочной сессии" :value="fastPurchaseJustificationTitle" />
                                <text-row-single-document v-if="form.purchase_terms.fast_purchase_justification_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Документ обоснования проведения срочной закупочной сессии" :value="form.purchase_terms.fast_purchase_justification_attachment" />
                            </template>
                            <text-row-boolean-text compact :label-cols-lg="4" :label-cols-sm="4" label="Аванс" :value="form.purchase_terms.with_advance" />
                            <text-row v-if="form.purchase_terms.with_advance" compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса" :value="form.purchase_terms.advance_percentage + '%'" />
                            <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="form.purchase_terms.planned_contract_conclusion_date" />
                            <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="form.purchase_terms.planned_contract_execution_date" />
                            <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="form.purchase_terms.contract_draft_attachment" />
                            <text-row-single-document v-if="form.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="form.purchase_terms.commercial_proposal_form_attachment" />
                            <text-row
                                compact
                                :label-cols-lg="4"
                                :label-cols-sm="4"
                                label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации"
                                :value="form.purchase_terms.unilateral_contract_termination_info"
                                text-wrap />

                            <hr />
                            <h4 class="font-weight-bold">Требования к участникам закупки</h4>
                            <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="form.supplier_requirements.only_smp" value-class="text-right" />
                            <text-row-boolean-text
                                compact
                                :label-cols-lg="11"
                                :label-cols-sm="11"
                                label="Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла"
                                :value="form.supplier_requirements.supplier_reqs_rating"
                                value-class="text-right" />
                            <text-row-boolean-text
                                compact
                                :label-cols-lg="11"
                                :label-cols-sm="11"
                                label="Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                                :value="form.supplier_requirements.supplier_reqs_a"
                                value-class="text-right" />
                            <b-container v-if="form.supplier_requirements.supplier_reqs_a">
                                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Описание требований" :value="form.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text" text-wrap />
                                <b-form-group :label-cols-sm="4" :label-cols-lg="4" label="Подтверждающие документы:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                    <ul>
                                        <li v-for="(item, index) in form.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + item.description }}</li>
                                    </ul>
                                </b-form-group>
                            </b-container>
                            <text-row-boolean-text
                                compact
                                :label-cols-lg="11"
                                :label-cols-sm="11"
                                label="Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                                :value="form.supplier_requirements.supplier_reqs_b"
                                value-class="text-right" />
                            <text-row-boolean-text
                                compact
                                :label-cols-lg="11"
                                :label-cols-sm="11"
                                label="Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                                :value="form.supplier_requirements.supplier_reqs_c"
                                value-class="text-right" />
                            <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участник является социально ориентированной некоммерческой организацией (СОНКО)" :value="form.supplier_requirements.supplier_reqs_sonko" value-class="text-right" />
                            <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Дополнительные требования к участникам закупки" :value="form.supplier_requirements.has_additional_requirements" value-class="text-right" />
                            <div v-show="form.supplier_requirements.has_additional_requirements">
                                <section style="width: 100%">
                                    <div class="table-responsive">
                                        <table class="atmo-content-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th class="atmo-ctc-width-45pct py-1">Описание</th>
                                                    <th class="atmo-ctc-width-45pct py-1">Причина или цель установки требования</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(requirement, index) in form.supplier_requirements.additional_requirements" v-bind:key="index">
                                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.description }}</td>
                                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.reason }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            </div>

                            <template v-if="form.delivery_terms.addresses.length > 0 || form.delivery_terms.schedule">
                                <hr />
                                <h4 class="font-weight-bold">Условия поставки</h4>
                                <b-form-group v-if="form.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                    <ul>
                                        <li v-for="(address, index) in form.delivery_terms.addresses" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + address.address ?? address }}</li>
                                    </ul>
                                </b-form-group>
                                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="form.delivery_terms.schedule" text-wrap />
                            </template>

                            <hr />
                            <h4 class="font-weight-bold">Спецификация</h4>
                            <b-form-group v-if="form.deliverables.length > 0">
                                <ul>
                                    <li v-for="(item, index) in form.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label py-1">{{ index + 1 + '.' }} {{ item.ktru.name }} - {{ item.okei.local_symbol }}</li>
                                </ul>
                            </b-form-group>

                            <template v-if="form.additional_documents.length > 0">
                                <hr />
                                <h4 class="font-weight-bold">Дополнительные документы</h4>
                                <text-row-documents label="Дополнительные документы" v-model="form.additional_documents" compact />
                            </template>
                        </b-tab>
                        <b-tab>
                            <template #title>
                                <span class="system_link-style fs-16">XML</span>
                            </template>
                            <b-form-textarea v-if="!isSignedXml" v-model="formXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                            <b-form-textarea v-else v-model="signedFormXml" disabled rows="20" no-resize no-auto-shrink wrap="off" class="text-monospace fs-12"></b-form-textarea>
                        </b-tab>
                    </b-tabs>
                </div>
                <div slot="modal-footer" class="w-100 px-3">
                    <text-row label="Сертификат" :value="certificate?.subjectName" />
                    <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                    <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                    </b-overlay>
                    <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                    </b-overlay>
                </div>
            </b-modal>
            <span id="atmo-bottom" class="atmo-hash-jump-point"></span>
        </b-container>
    </div>
</template>

<script>
import { helpers, maxValue, minLength, minValue, numeric, required, requiredIf } from 'vuelidate/lib/validators';
import setFastAccessMenuTop from '@lib/js/src/misc/setFastAccessMenuTop';
import TextRowSingleDocument from '@/components/common/form-rows/text-row-single-document.vue';
import { createMultipleSignatures, getCertificate } from 'crypto-pro';
import moment from 'moment-timezone';
import range from 'lodash.range';
import FormRowEditNumber from '@/components/common/form-rows/form-row-edit-number.vue';
import SupplierRequirementSupplierReqsAEditTable from '@/components/products/fl44/partials/supplier-requirement-supplier-reqs-a-edit-table.vue';
import AdditionalSupplierRequirementsEditTable from '@/components/products/fl44/partials/additional-supplier-requirements-edit-table.vue';
import Config from '@core/js/ddriven/application/config/Config';
import FormRowSingleLineMultipleDocumentsUpload from '@/components/common/form-rows/form-row-single-line-multiple-documents-upload.vue';
import cloneDeep from 'lodash.clonedeep';
import OnlineCourseRegularButton from '@/components/elements/OnlineCourseRegularButton.vue';

const minDate = (param) => helpers.withParams({ type: 'minDate', minDate: param }, value => moment(value).isSameOrAfter(moment(param)));

export default {
    name: 'fl44-unknown-volume-purchase-create',
    metaInfo() {
        return {
            title: this.isModeEdit ? 'Редактирование закупки 44ФЗ с неопределённым объёмом ' + this.getRegNumber : 'Создание закупки 44ФЗ с неопределённым объёмом'
        };
    },
    components: {
        OnlineCourseRegularButton,
        FormRowSingleLineMultipleDocumentsUpload,
        AdditionalSupplierRequirementsEditTable,
        SupplierRequirementSupplierReqsAEditTable,
        FormRowEditNumber,
        TextRowSingleDocument,
    },
    validations() {
        return {
            form: {
                purchase_terms: {
                    contact_info: {},
                    comment: {},
                    purchase_object: { required },
                    deliverable_group_id: { required },
                    order_type_id: { required },
                    contract_price: {
                        required,
                        minValue: minValue(1),
                        maxValue: maxValue(this.currentLimit),
                    },
                    duration_type: { required },
                    fast_purchase_justification: { required: requiredIf(() => this.form.purchase_terms.duration_type === 'fast') },
                    fast_purchase_justification_attachment: {},
                    purchase_limit_year: { required: requiredIf(() => !this.form.purchase_terms.without_limits) },
                    advance_percentage: {
                        required: requiredIf(() => this.form.purchase_terms.with_advance),
                        minValue: this.form.purchase_terms.with_advance ? minValue(1) : true,
                        maxValue: this.form.purchase_terms.with_advance ? maxValue(30) : true,
                        numeric,
                    },
                    planned_contract_conclusion_date: { required },
                    planned_contract_execution_date: {
                        required,
                        minDate: minDate(this.form.purchase_terms.planned_contract_conclusion_date)
                    },
                    unilateral_contract_termination_info: {},
                    contract_draft_attachment: { required },
                    commercial_proposal_form_attachment: {}
                },
                supplier_requirements: {
                    only_smp: {},
                    supplier_reqs_rating: {},
                    supplier_reqs_a: {},
                    supplier_reqs_a_details: {
                        supplier_reqs_a_text: {
                            required: requiredIf(() => this.form.supplier_requirements.supplier_reqs_a)
                        },
                        supplier_reqs_a_documents: {
                            required: requiredIf(() => this.form.supplier_requirements.supplier_reqs_a),
                            minLength: minLength(1),
                            $each: {
                                description: {
                                    required
                                }
                            }
                        }
                    },
                    supplier_reqs_b: {},
                    supplier_reqs_c: {},
                    supplier_reqs_sonko: {},
                    has_additional_requirements: {},
                    additional_requirements: {
                        required: requiredIf(() => this.form.supplier_requirements.has_additional_requirements),
                        minLength: minLength(1),
                        $each: {
                            description: {
                                required
                            },
                            reason: {
                                required
                            }
                        }
                    }
                },
                delivery_terms: {
                    addresses: {},
                    schedule: {}
                },
                deliverables: {
                    required,
                    minLength: minLength(1),
                    $each: {
                        ktru_item_id: { required },
                    }
                },
                additional_documents: {
                    $each: {
                        id: { required }
                    }
                }
            }
        };
    },
    data() {
        return {
            isLoading: true,
            isSigningXml: false,
            isDataSending: false,
            id: null,
            formXml: '',
            signedFormXml: null,
            isSignedXml: false,
            showSignModal: false,
            customer: {},
            dictionaries: {
                limitYears: []
            },
            form: {
                reg_number: null,
                purchase_terms: {
                    contact_info: '',
                    comment: '',
                    purchase_object: '',
                    order_type_id: 2,
                    contract_price: null,
                    deliverable_group_id: null,
                    duration_type: 'normal',
                    fast_purchase_justification: null,
                    fast_purchase_justification_attachment: null,
                    without_limits: false,
                    purchase_limit_year: new Date().getFullYear(),
                    with_advance: false,
                    advance_percentage: null,
                    planned_contract_conclusion_date: null,
                    planned_contract_execution_date: null,
                    unilateral_contract_termination_info: '',
                    contract_draft_attachment: null,
                    commercial_proposal_form_attachment: null
                },
                supplier_requirements: {
                    only_smp: false,
                    supplier_reqs_rating: false,
                    supplier_reqs_a: false,
                    supplier_reqs_a_details: {
                        supplier_reqs_a_text: null,
                        supplier_reqs_a_documents: []
                    },
                    supplier_reqs_b: true,
                    supplier_reqs_c: false,
                    supplier_reqs_sonko: false,
                    has_additional_requirements: false,
                    additional_requirements: []
                },
                delivery_terms: {
                    addresses: [],
                    schedule: null
                },
                additional_documents: [],
                deliverables: [],
                limits: {
                    items: []
                }
            },
            restrictions: {
                was_canceled: false
            },
            isLimitsValid: false,
            signedAttachments: [],
            certificate: null
        };
    },
    async mounted() {
        setFastAccessMenuTop();
        await this.fillData();
        this.isLoading = false;
    },
    methods: {
        moment,
        async fillData() {
            range(2019, new Date().getFullYear() + 2).forEach((year) => {
                this.dictionaries.limitYears.push({ id: year, label: year });
            });
            let response;
            if (this.isModeEdit) {
                this.id = this.$route.params.id;
                response = await this.$api.products.fl44UnknownVolume.purchases.getDraft(this.id);
                this.form.reg_number = response.reg_number;
                this.restrictions = response.restrictions;
                this.form = Object.assign({}, this.form, response.draft_data);
            } else {
                response = await this.$api.products.fl44UnknownVolume.purchases.retrieveTemplate();
            }
            this.customer = response.customer;
            this.dictionaries = Object.assign({}, this.dictionaries, response.dictionaries);
        },
        onDateInput(value) {
            if (value === null) this.form.purchase_terms.planned_contract_execution_date = value;
        },
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
        },
        async saveDraft() {
            if (this.isModeEdit) {
                await this.$api.products.fl44UnknownVolume.purchases.updateDraft(this.id, this.prepareDraftData());
            } else {
                const response = await this.$api.products.fl44UnknownVolume.purchases.createDraft(this.prepareDraftData());
                if (response) {
                    this.id = response.id;
                    this.form.reg_number = response.reg_number;
                    if (!(Object.prototype.hasOwnProperty.call(this.$route.params, 'id') && +this.$route.params.id === this.id)) {
                        await this.$router.replace({ name: 'Fl44UnknownVolumePurchaseEdit', params: { id: this.id } });
                    }
                }
            }
        },
        clearAdditionalRequirements() {
            this.form.supplier_requirements.additional_requirements = [];
            this.$v.$reset();
        },
        clearSupplierReqsA() {
            this.form.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text = null;
            this.form.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents = [];
            this.$v.$reset();
        },
        prepareDraftData() {
            const draftData = cloneDeep(this.form);
            draftData.deliverables = draftData.deliverables.map(item => {
                return {
                    ktru_item_id: item.ktru_item_id
                }
            });
            return draftData;
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        async validateForm() {
            await this.saveDraft();
            if (!this.$store.getters.getCanSign) {
                return;
            }
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.showSignForm();
        },
        showSignForm() {
            this.$api.products.fl44UnknownVolume.purchases.getXml(this.id).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                }
            ];
            for (const attachment of [this.form.purchase_terms.contract_draft_attachment, this.form.purchase_terms.fast_purchase_justification_attachment, this.form.purchase_terms.commercial_proposal_form_attachment, ...this.form.additional_documents]) {
                if (attachment !== null) {
                    dataToSign.push({
                        method: 'detached',
                        value: attachment.hash
                    });
                }
            }
            try {
                const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true);
                this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
                this.signedAttachments.splice(0);
                for (const attachment of [this.form.purchase_terms.contract_draft_attachment, this.form.purchase_terms.fast_purchase_justification_attachment, this.form.purchase_terms.commercial_proposal_form_attachment, ...this.form.additional_documents]) {
                    if (attachment !== null) {
                        const result = signedResult.find((item) => item.method === 'detached' && item.value === attachment.hash);
                        this.signedAttachments.push({
                            id: attachment.id,
                            hash: attachment.hash,
                            md5: result.result
                        });
                    }
                }
                this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === this.form.additional_documents.length + (this.form.purchase_terms.fast_purchase_justification_attachment ? 2 : 1) + (this.form.purchase_terms.commercial_proposal_form_attachment ? 1 : 0) && this.signedAttachments.every((item) => item.md5 !== null);
            } catch (e) {
                await this.$store.dispatch('showDangerToast', e.message);
            } finally {
                this.isSigningXml = false;
            }
        },
        async sendData() {
            this.isDataSending = true;
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            await this.$api.products.fl44UnknownVolume.purchases
                .storeSigned(this.id, this.form, this.signedFormXml, this.certificate, this.signedAttachments)
                .then((response) => {
                    if (response) {
                        this.onCancel();
                    }
                })
                .finally(() => {
                    this.isDataSending = false;
                });
        },
        onCancel() {
            this.$router.push({ name: 'CabinetFl44NoticesList' });
        }
    },
    computed: {
        features() {
            return Config.get('theme.features');
        },
        withoutLimits() {
            return this.$store.state.fl44_without_limits ?? false;
        },
        isModeEdit() {
            return !!this.$route.params.id && this.$route.name === 'Fl44UnknownVolumePurchaseEdit';
        },
        getRegNumber() {
            return this.form?.reg_number ?? '';
        },
        currentDurationType() {
            return this.form.purchase_terms.duration_type ? this.$globalDictionaries.fl44PurchaseDurationTypes?.find((i) => i.id === this.form.purchase_terms.duration_type) : null;
        },
        purchaseId() {
            return null;
        },
        currentOrderType() {
            return this.$globalDictionaries.orderTypes.find((item) => item.id === this.form.purchase_terms.order_type_id);
        },
        currentLimit() {
            return this.currentOrderType.max_amount;
        },
        costState() {
            return this.form.purchase_terms.contract_price > 0 && this.form.purchase_terms.contract_price <= this.currentLimit;
        },
        specErrors() {
            return !!this.specErrorMessage;
        },
        specErrorMessage() {
            if (this.form.deliverables.length === 0) return 'Заполните таблицу спецификаций';
            return '';
        },
        isValid() {
            const kbk_limits = this.features.kbk_limits ? this.isLimitsValid || this.form.purchase_terms.without_limits : true;
            return this.costState && !this.specErrors && kbk_limits && !this.$v.$invalid;
        },
        fastPurchaseJustificationTitle() {
            return this.dictionaries.urgency_reasons.find((item) =>item.id === this.form.purchase_terms.fast_purchase_justification)?.title;
        }
    }
};
</script>

<style scoped>
.atmo-hash-jump-point {
    scroll-margin-top: 190px;
}
</style>
